import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Index = () => import("/page/index.vue");
const Home = () => import("/page/Home/index.vue");
const Goods = () => import("/page/Goods/index.vue");
const GoodsDetails = () => import("/page/Goods/details.vue");

const User = () => import("/page/User/index.vue");
const OrderList = () => import("/page/User/children/orderList.vue");
const OrderDetails = () => import("/page/User/children/orderDetails.vue");
const AddressList = () => import("/page/User/children/addressList.vue");

const Checkout = () => import("/page/Checkout/index.vue");

const Game = () => import("/page/Game/index.vue");

export const whiteList = ["/", "/home", "/goods", "/goodsDetails", "/game"];

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      redirect: "/home",
      children: [
        { path: "home", component: Home },
        { path: "goods", component: Goods },
        { path: "goodsDetails", name: "goodsDetails", component: GoodsDetails },
      ],
    },
    {
      path: "/user",
      name: "user",
      component: User,
      redirect: "/user/orderList",
      children: [
        { path: "orderList", name: "orderList", component: OrderList },
        { path: "orderDetails", name: "orderDetails", component: OrderDetails },
        { path: "addressList", name: "addressList", component: AddressList },
      ],
    },
    { path: "/checkout", name: "checkout", component: Checkout },
    { path: "/game", name: "game", component: Game },
    { path: "*", redirect: "/home" },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js